export default "__VITE_ASSET__DFCPVKSK__"